'use client';

import {Box, IconButton, styled} from '@mui/material';

export const StyledTopicPageSocialLinksContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3),
  marginTop: theme.spacing(1),
}));

export const StyledTopicPageShareButton = styled(IconButton)(({theme}) => ({
  padding: 0,
  color: 'inherit',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.short,
  }),
  '&:hover': {
    transform: 'scale(1.1)',
    backgroundColor: 'transparent',
  },
  '&:active': {
    transform: 'scale(0.95)',
  },
}));
